/**
 * navSource — RW-1789. A one-shot marker connecting a navigation trigger
 * (rail click, search hit) to the route change it causes, so
 * NAV_ROUTE_REACHED can record HOW a destination was reached. Anything
 * unmarked — deep link, browser back/forward, in-app link — reads as
 * 'other'. The mark expires after a short window so a click that never
 * navigated cannot mislabel a later, unrelated route change.
 */
let source = null;
let markedAt = 0;
const FRESH_MS = 1500;

export function markNavSource(via) {
  source = via;
  markedAt = Date.now();
}

export function consumeNavSource() {
  const fresh = source && (Date.now() - markedAt) < FRESH_MS ? source : null;
  source = null;
  return fresh || 'other';
}
